<template>
    <div class="header-goback">
        <i class="el-icon-back" @click="handleClickGoBack"></i>
        <span>{{titleName}}</span>
    </div>
</template>

<script>
export default {
    name:'headerGoback',
    props:['titleName'],
    data() {
        return {
            
        }
    },

    watch:{
        
    },

    methods:{
        handleClickGoBack() {
            this.$router.go(-1)
        },
    }
}
</script>

<style lang="scss" scoped>
    .header-goback{
        width: 100%;
        height: 58px;
        color: #333333;
        font-size: 18px;
        border-bottom: 1px solid  #eaeaea;
        display: flex;
        align-items: center;
        i{
            margin-right: 10px;
            cursor: pointer;
            font-size: 22px;
            // font-weight: 800;
        }
    }

</style>